
<template>
  <v-app id="searchKstp">
    <v-main>
    <v-container fluid>  
    <v-card>
      <v-card-title>Additional Costs</v-card-title>
      <v-simple-table dense>
         <thead>
           <tr>
             <td>Nr</td>
             <td>Active</td>
             <td>Type ID</td>
             <td>Type Description</td>
             <td>Type Man/Opt</td>
             <td colspan=2 align="center">In Rent</td>
             <td>Payment</td>
             <td>In Rent RU</td>
             <td>Description</td>
           </tr>  
         </thead>  
         <tbody v-for="(kstpRecord,i) in searchKstp" :key="i">
           <tr @click="$router.reload('/syst/ref/kstp/onKstp/' + kstpRecord.kstp_encrid)">
             <td>{{kstpRecord.kstp_nr}}</td>
             <td>{{kstpRecord.kstp_actief}}</td>
             <td>{{kstpRecord.ktpt_nr}}</td>
             <td>{{kstpRecord.ktpttaal_oms}}</td>
             <td>{{kstpRecord.kstp_cat}}</td>
             <td>{{kstpRecord.kstp_in_rent}}</td>
             <td>{{kstpRecord.kstp_nr_in_rent}}</td>
             <td>{{kstpRecord.kstp_betaling}}</td>
             <td>{{kstpRecord.kstptaal_oms}}</td>
           </tr>  
         </tbody>  
       </v-simple-table>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/>   
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      searchKstp: []
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/kstp/searchKstp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchKstp"
          },
          searchKstp: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.searchKstp = res.data.searchKstp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
};

</script> 
